import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import * as globals from '../globals';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

@Injectable()
export class useradminService {

  private userurl = globals.APIURL + '/user';
  private adminuserurl = this.userurl + '/admin';
  private roleuserurl = this.userurl + '/role';
  public roleID: number;
  constructor(private http: Http, public authHttp: AuthHttp) { }
  // get all Users
  getUser(): Observable<string> {
    console.log('get users service called');
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.userurl);
    return this.authHttp.get(this.userurl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Add a user
  addNewUser(registrationUser, roles): Observable<string> {
    console.log('addNewUser service method called');

    this.roleID = registrationUser.role;

    // Got to do this because we don't want to send password anymore
    let body = JSON.stringify({
      email: registrationUser.email, firstname: registrationUser.firstname,
      lastname: registrationUser.lastname, phone: registrationUser.phone,
      company: registrationUser.company, planid: registrationUser.planid, role: roles
      // addinfo:registrationUser.addinfo, primary:registrationUser.primary
    });

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    console.log('Login: URL =>', this.adminuserurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);
    return this.authHttp.post(this.adminuserurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // add User in Database
  addUserDatabase(registrationUser, roles): Observable<string> {

    let body = JSON.stringify({
      email: registrationUser.email, firstname: registrationUser.firstname,
      lastname: registrationUser.lastname, phone: registrationUser.phone,
      company: registrationUser.company, planid: registrationUser.planid, roles: roles
      // addinfo:registrationUser.addinfo, primary:registrationUser.primary
    });

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    console.log('Login: URL =>', this.userurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);
    return this.authHttp.post(this.userurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  deleteUserLoginRecord(email): Observable<string> {
    let body = JSON.stringify({ username: email });
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ body: body, headers: headers });
    console.log('Login: URL =>', this.adminuserurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);
    return this.authHttp.delete(this.adminuserurl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Update a user's info to set enabled to 2 (deleted)
  deleteUserFromDatabase(id): Observable<string> {
    console.log('deleteUserFromDatabase service method called');

    let body = JSON.stringify({ id: id, enabled: 2 });

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    console.log('Login: URL =>', this.userurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);

    return this.authHttp.put(this.userurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Delete a user by their userid and roleid
  deleteUserRole(userID, roleId): Observable<string> {
    let body = JSON.stringify({ userid: userID, roleid: roleId });

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ body: body, headers: headers });
    console.log('Login: URL =>', this.roleuserurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);
    return this.authHttp.delete(this.roleuserurl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Add a role for a user
  addRoleToUser(userID, roleId): Observable<string> {
    let body = JSON.stringify({ userid: userID, roles: roleId });
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    console.log('Login: URL =>', this.roleuserurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);
    return this.authHttp.post(this.roleuserurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Update a user's info Enable disable
  updateUserInformation(id, firstname, lastname, phone, isEnabled): Observable<string> {
    console.log('updateUserInfo service method called');

    let body = JSON.stringify({ id: id, firstname: firstname, lastname: lastname, phone: phone, enabled: isEnabled });

    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    console.log('Login: URL =>', this.userurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);

    return this.authHttp.put(this.userurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Update a user's info Enable disable
  changesActivityStateOfUser(userID, state): Observable<string> {
    let body = JSON.stringify({ id: userID, enabled: state });
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    console.log('Login: URL =>', this.userurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);

    return this.authHttp.put(this.userurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }


  // Update a user's info Enable disable
  changesActivityStateOfUserCognito(emailID, state): Observable<string> {
    let body = JSON.stringify({ email: emailID, enabled: Number(state) });
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });

    console.log('Login: URL =>', this.adminuserurl);
    console.log('Login: BODY =>', body);
    console.log('Login: OPTIONS =>', options);

    return this.authHttp.put(this.adminuserurl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  // Get all roles for a given userid
  getallusersrole(userID) {
    console.log('get users all roles service called');
    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({ body: '', headers: headers });
    console.log('Projects: OPTIONS =>', options);
    console.log('URL:', this.roleuserurl);
    return this.authHttp.get(this.roleuserurl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    let body = res.json();
    console.log('BODY:', body);
    return body || {};
  }

  handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error('CAUGHT AN ERROR:', errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/useradmin/useradmin.service.ts